
import albaConfig from "@/apps/alba/app.config"

//Order here corresponds to the order in the left navigation
var configs = [
    albaConfig,
    
];


var registrationConfig = configs.map(e => {
    return {
        store: e.storeModule,
        route: e.route,
        navigation: {
            name : e.name,
            route : e.parentRoute,
            icon: e.icon,
            description : e.description,
            color : e.accentColor,
            children : e.navigation.map(nav => {
                return {
                    name : nav.title,
                    route : `${e.parentRoute}/${nav.route}`,
                    icon: nav.icon,
                }
            })
        }
    }
});

export default registrationConfig;
